import { default as _91_46_46_46slug_93xFYcWBIF46Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/[...slug].vue?macro=true";
import { default as indexgjz1rdjZzzMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/auth/index.vue?macro=true";
import { default as indexrkzLQUPPviMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as datenschutzD5pnpnNJWJMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/datenschutz.vue?macro=true";
import { default as datenverarbeitungiCeLnBtiFxMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/datenverarbeitung.vue?macro=true";
import { default as _91id_93cLE6Fbxw4ZMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_932EOknrbZOFMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/formProcess/success/[id].vue?macro=true";
import { default as impressumedMje3RtxvMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/impressum.vue?macro=true";
import { default as index3mUXruR35jMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/index.vue?macro=true";
import { default as _91slug_93Iqnc8yby3fMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/news/[slug].vue?macro=true";
import { default as organisationsOqXm4dj0sMMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/organisations.vue?macro=true";
import { default as index14oBIdWsfUMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/processes/index.vue?macro=true";
import { default as dungeonjdbSVL5XDQMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputswl0oxsCTNSMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexBr2xgybNZOMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/secret/index.vue?macro=true";
import { default as indexgrxVqnnH11Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataBrzTu5lQImMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassujf4pxAeldMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93aWkpbKQCVGMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexONkyamWT8YMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataar1dZSjfSRMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramReportsxBCgUxtu7YMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsjniDEAehQ9Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93vbF8tbdNReMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexEqNpmDvQPKMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesB6uZ0YgdHSMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataYWVAJIkNT3Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93qKmEYJdrDHMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexJvEyRZ1L1FMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesEZnjhuxeX2Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataYgnEShbM9cMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93mUnkD6ZGgzMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexk9hFjc9QAhMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataOsP2U0KRfYMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_935k9qSNaMl4Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexiKyVtRzDchMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statusActivitiesFGs1H4QQ7WMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataUWCZ9Hbi5gMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsndsHeAV5atMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93eC96xMvrWVMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexjHoXDcwMA3Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseData1pP2rBM6z5Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatawcd9ajAXZoMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as yearInterviewsS0NymViDE0Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/[id]/yearInterviews.vue?macro=true";
import { default as _91id_93FDgeeg1TASMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as index0vTNq6L8MFMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicData64c0ghpO8NMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93E57jNMKAZQMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexPnJwDndTwpMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/index.vue?macro=true";
import { default as paymentRunActivitiesoWR7oEHfWJMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue?macro=true";
import { default as paymentRunBaseDataigsls7LKOdMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsSFDlBKfq8lMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93A8yh0LBDLeMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as index74mZAg5DFdMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsWyEZqrMYIOMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesu4WimImFenMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataFxoAlYdRlJMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93MuQ7UEvEcfMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/[id].vue?macro=true";
import { default as indexkdaBjrj463Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalpFp5RpvPcvMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93kpvWrBjtyNMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexSIwvxwSHUdMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersEcShOZq5IMMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesCqRKTjIB56Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsjmyHIBYMX4Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseData6EerQ9vfhWMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories83pUr5OVciMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConceptyEmHtZu2SvMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheetaOtnzOVc88Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUsersMGGpRMnfFOMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_936mrucXLp7mMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexGqysCFBT7jMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsVnn62zH9fRMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitieszwIjiPa6YKMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseData1V5oJLFEDuMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltersQ9ehAZQZFCMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatureCNlkOpN0JKMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93i25BwoZZVJMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexzO463iiMBgMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersZC2ivJHuisMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users.vue?macro=true";
import { default as settingsjKT17K1ysyMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings.vue?macro=true";
import { default as serviceHcQiHcktrrMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service.vue?macro=true";
import { default as indexmtprSicHzOMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/childOrganisations/index.vue?macro=true";
import { default as languageHigS98dezpMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataY7eIugKgtCMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesvp2bPL7lXnMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConceptnqzpSiGqMOMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheetbqB9aztCcZMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUsersebOWcmtQmGMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93KSHPhUmPl2Meta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseData5n5tV37SCFMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignaturev1avJCRupVMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93QdHNdk0bIPMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/users/[id].vue?macro=true";
import { default as settingsLYjKBg6OzmMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings.vue?macro=true";
import { default as signaturesbEH9grSjJMeta } from "/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/signature.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93xFYcWBIF46Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexgjz1rdjZzzMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexrkzLQUPPviMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/datenschutz.vue")
  },
  {
    name: "datenverarbeitung",
    path: "/datenverarbeitung",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/datenverarbeitung.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93cLE6Fbxw4ZMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_932EOknrbZOFMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/impressum.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index3mUXruR35jMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/index.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsOqXm4dj0sMMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: index14oBIdWsfUMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/processes/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceHcQiHcktrrMeta?.name,
    path: "/service",
    meta: serviceHcQiHcktrrMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicData64c0ghpO8NMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexgrxVqnnH11Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93aWkpbKQCVGMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexONkyamWT8YMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93vbF8tbdNReMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexEqNpmDvQPKMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93qKmEYJdrDHMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexJvEyRZ1L1FMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93mUnkD6ZGgzMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexk9hFjc9QAhMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_935k9qSNaMl4Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexiKyVtRzDchMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93eC96xMvrWVMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsndsHeAV5atMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexjHoXDcwMA3Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93FDgeeg1TASMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/[id]/yearData.vue")
  },
  {
    name: "service-basicData-years-id-yearInterviews",
    path: "yearInterviews",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/[id]/yearInterviews.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: index0vTNq6L8MFMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93E57jNMKAZQMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/index.vue")
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsWyEZqrMYIOMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93A8yh0LBDLeMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunActivities",
    path: "paymentRunActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: index74mZAg5DFdMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93MuQ7UEvEcfMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexkdaBjrj463Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalpFp5RpvPcvMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsjKT17K1ysyMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersEcShOZq5IMMeta?.name,
    path: "loginProviders",
    meta: loginProvidersEcShOZq5IMMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93kpvWrBjtyNMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexSIwvxwSHUdMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsVnn62zH9fRMeta?.name,
    path: "organisations",
    meta: organisationsVnn62zH9fRMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_936mrucXLp7mMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexGqysCFBT7jMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersZC2ivJHuisMeta?.name,
    path: "users",
    meta: usersZC2ivJHuisMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93i25BwoZZVJMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexzO463iiMBgMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsLYjKBg6OzmMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings.vue"),
    children: [
  {
    name: "settings-childOrganisations",
    path: "childOrganisations",
    meta: indexmtprSicHzOMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/childOrganisations/index.vue")
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93KSHPhUmPl2Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93QdHNdk0bIPMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signaturesbEH9grSjJMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261029104557/client/pages/signature.vue")
  }
]